import React from 'react';
import { Dialog, DialogContent, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface VideoPlayerModalProps {
  onClose: () => void;
  videoUrl: string;
  poster?: string;
}

const VideoPlayerModal: React.FC<VideoPlayerModalProps> = ({
  onClose,
  videoUrl,
  poster,
}) => (
  <Dialog
    open={true}
    onClose={onClose}
    maxWidth="md"
    PaperProps={{
      sx: {
        borderRadius: 4,
        background: '#181818',
        boxShadow: 24,
      },
    }}
    fullScreen
  >
    <DialogContent sx={{ position: 'relative', p: 0 }}>
      <IconButton
        onClick={onClose}
        sx={{
          position: 'absolute',
          top: 8,
          right: 8,
          color: '#fff',
          zIndex: 10,
          background: 'rgba(30,30,30,0.6)',
          '&:hover': { background: 'rgba(30,30,30,0.9)' },
        }}
      >
        <CloseIcon />
      </IconButton>
      <video
        src={videoUrl}
        poster={poster}
        controls
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'contain',
          background: '#000',
          borderRadius: 18,
          outline: 'none',
        }}
        preload="auto"
        playsInline
        autoPlay
      >
        Video is not supported
      </video>
    </DialogContent>
  </Dialog>
);

export default VideoPlayerModal;
